export enum LocalizationItem {
  Hello = 'Hello',
  SignOut = 'SignOut',
  UpgradeToConsultant = 'UpgradeToConsultant',
  UpgradeToBrandPartner = 'UpgradeToBrandPartner',
}
